import React, { useEffect, useState } from "react";
import { CloseIcon, CopyIcon } from "../../assets/images";
import "./timesheet.scss";

type AppProps = {
  data: any;
  handleDeleteTimeSheet: (data: string) => void;
  handleEdit: (data: any) => void;
  handleCopy: (e: any, data: any) => void;
  finalClientList: any;
  finalJobList: any;
  allActivityCode: any;
  handleCopyTimeSheetModal: () => void;
  sharedJob?: boolean;
  editTimeSheet?: boolean;
  deleteTimeSheet?: boolean;
  editDateTimesheet?:boolean;
};

const TimeSheetCard = ({
  data,
  handleDeleteTimeSheet,
  handleEdit,
  handleCopy,
  finalClientList,
  finalJobList,
  allActivityCode,
  handleCopyTimeSheetModal,
  sharedJob,
  editTimeSheet,
  deleteTimeSheet,
  editDateTimesheet
}: AppProps) => {
  const [listData, setListData] = useState<any>({
    clientLabel: "",
    activityCodeLabel: "",
    activityDescLabel: "",
  });

  useEffect(() => {
    if (finalClientList?.length > 0 && data?.client_code) {
      let findClient = finalClientList?.find(
        (el: any) => el.value == data?.client_code
      );

      setListData((prev: any) => {
        return {
          ...prev,
          clientLabel: findClient?.label,
        };
      });
    }
  }, [finalClientList, data]);

  useEffect(() => {
    if (allActivityCode?.length > 0 && data?.activity_code) {
      let findClient = allActivityCode?.find(
        (el: any) => el?._id == data?.activity_code
      );
      setListData((prev: any) => {
        return {
          ...prev,
          activityCodeLabel: findClient?.activity_code,
          activityDescLabel: findClient?.description,
        };
      });
    }
  }, [allActivityCode, data]);
  return (
    <div
      className={editDateTimesheet ? "cardTimesheet" : "cardTimesheetDisable mt-4"}
      style={{ 
        cursor: editDateTimesheet ? "pointer" : "not-allowed",
       }}
      onClick={() => {
        if (editDateTimesheet && editTimeSheet) {
          handleEdit(data); 
        }
      }}
      
    >
      <div className="list-header">
        <div className="inside-card-header d-flex">
          {`${data?.start_time} To ${data?.end_time}`}
          <span>
            (
            {typeof data?.time_difference === "string"
              ? parseFloat(data?.time_difference).toFixed(2)
              : "N/A"}
            )
          </span>

          <div
            className="ml-2 d-flex align-items-center justify-content-center"
            style={{
              backgroundColor: data?.type == 1 ? "#e3efff" : "#ede6fc",
              color: data?.type == 1 ? "#2080f6" : "#744bd1",
              padding: "5px 7px",
              fontSize: "12px",
              borderRadius: "11px",
            }}
          >
            {data?.type == 1 ? "Billable" : "Non-Billable"}
          </div>
          {data?.shared_job ? (
            <div
              className="ml-2 d-flex align-items-center justify-content-center"
              style={{
                color: "#6e7491",
                backgroundColor: "#eef1f4",
                fontSize: "12px",
                borderRadius: "11px",
                padding: "5px 7px",
              }}
            >
              {data?.shared_job ? "Shared job" : ""}
            </div>
          ) : (
            ""
          )}
        </div>

        <div
          // style={{         }}
          onClick={() => {
            deleteTimeSheet && editDateTimesheet &&handleDeleteTimeSheet(data._id);
          }}
        >
          <img
            className="mr-3"
            style={{cursor: "pointer"}}
            src={CopyIcon}
            onClick={(e: any) => {
              handleCopyTimeSheetModal();
              handleCopy(e, data);
            }}
            alt="copy_icon"
          />
          {deleteTimeSheet && <img style={{cursor: editDateTimesheet ? "pointer" : "not-allowed"}} src={CloseIcon} alt="" />
          }
        </div>
      </div>

      {data?.type == 1 ? (
        <div className="mt-2 mb-1 inside-card-sub-heading">
          <span className="text-style-1">{data?.job?.job}</span>
          On
          <span className="text-style-1 ml-1 mr-1">
            {data?.activity_code_details?.activity_code} {data?.job?.code} (
            {data?.job?.job_name})
          </span>
          {data?.client_details?.company_name
            ? `for  ${data?.client_details?.company_name} (${data?.client_details?.client_code})  `
            : ""}
        </div>
      ) : (
        <div className="mt-2 mb-1 inside-card-sub-heading">
          <span className="text-style-1">
            {data?.activity_code_details?.activity_code}
          </span>
        </div>
      )}

      <hr />

      <div className="mt-1 mb-2 label">{data?.comments}</div>
    </div>
  );
};

export default TimeSheetCard;
